import { window } from '../../../../globals';
import queryClient from '../../../../ReactQuery/client';
import useMutation from '../../../../ReactQuery/useMutation';
import { post } from '../../../../redux/api';
import type {
  NewNotificationWebhookRequest,
  NotificationWebhookResponse,
} from '../../../../../shared/settings/apiWebhooks';

import { getApiWebhookSettingsQueryKey } from './useGetApiWebhookSettings';

function createApiWebhook(orgId: number, newWebhook: NewNotificationWebhookRequest) {
  return post<NewNotificationWebhookRequest[], { results: NotificationWebhookResponse[] }>(`/api/organizations/${orgId}/settings/integrations/api-webhooks`, [newWebhook]);
}

/**
 * Creates a mutation that creates an API webhook setting for the org.
 */
export default function useCreateApiWebhookSetting() {
  return useMutation({
    mutationFn: (newWebhook: NewNotificationWebhookRequest) =>
      createApiWebhook(window.user?.organizationId ?? 0, newWebhook),
    onSuccess: () => {
      queryClient.invalidateQueries(getApiWebhookSettingsQueryKey(window.user?.organizationId ?? 0));
    },
  });
}
